<div id="address_search" class="map__address-search">
  <div class="input-group">
    <input maxlength="255" type="text" class="address-search__input" placeholder="{{'address-search.placeholder' | translate}}"
           id="address_search_input" [(ngModel)]="gSearch" (keydown)="onKeydown($event)"
           appAutocompleteOff/>
    <div class="input-group-append cursor-pointer address-search__icon"
         (click)="enablePlanner()"><i class="ico-location"></i></div>
  </div>
  <div *ngIf="searchResults.length > 0" class="address-search__dropdown" aria-labelledby="dropdownMenuButton">
    <a class="address-search__dropdown-item" href="javascript:void(0)" *ngFor="let result of searchResults, let idx = index"
       id="item-{{idx}}" (click)="showResultOnMap(result)">{{result.name}}</a>
    <a class="address-search__dropdown-item address-search__show-more hidden" id="show-more" (click)="showMore()">{{'route.map.showMore' | translate}}</a>
  </div>
  <div *ngIf="recenterLastMarker"
       class="address-search__controls"
       (click)="recenterMapToPoint(lastMarkerPosition)"
       title="{{'route.map.recenter' | translate}} ({{getMarkerLocation()}})">
    <i class="ico-map-marker sz-xs"></i>
    <span class="address-search__point-position">{{getMarkerLocation()}}</span>
    <i class="ico-close" (click)="clearLastPositionMarker()"></i>
  </div>
</div>
